import { Img, Button } from "@chakra-ui/react";
import React from "react";
import { useNavigate } from "react-router-dom";

interface CognizantPopupProps {
  nextUnlock: number | string;
  popupMode: string // "unlock" | "congrats";
  onCancel: () => void;
  onContinue: () => void;
  GameId: number | string;
  preloadedAssets:any;
}

const CognizantPopup: React.FC<CognizantPopupProps> = ({
  nextUnlock,
  popupMode,
  onCancel,
  onContinue,
  GameId,
  preloadedAssets,
}) => {
  const navigate = useNavigate();

  /** ---- SAFE GAME ID PARSING ---- **/
  const currentGameId = parseInt(String(GameId).trim(), 10);
  const validGameId = isNaN(currentGameId) ? null : currentGameId;

  /** ---- POPUP MESSAGES ---- **/
  const messages: Record<number, { title: React.ReactNode; description: string }> = {
    191: {
      title: renderTitle(preloadedAssets?.Blink, "Level Up!"),
      description: `You’ve unlocked Level 2 of Giving Feedback.
Click Continue to dive into Level 2, or Cancel to stay here and replay Level 1.
You can always return to Level 2 later from the Home Page.`,
    },
    184: {
      title: renderTitle(preloadedAssets?.Blink, "Challenge Complete!"),
      description: `You’ve conquered both levels of Giving Feedback.
Click Continue to return to the Home Page, or Cancel to replay this Level.`,
    },
    188: {
      title: renderTitle(preloadedAssets?.Blink, "Level Up!"),
      description: `You’ve unlocked Level 2 of Conflict Management.
Click Continue to dive into Level 2, or Cancel to stay here and replay Level 1.
You can access Level 2 anytime using the Home Page.`,
    },
    189: {
      title: renderTitle(preloadedAssets?.Blink, "Challenge Complete!"),
      description: `You’ve conquered both levels of Conflict Management.
Click Continue to return to the Home Page, or Cancel to replay this Level.`,
    },
  };

  const popupMessage = validGameId ? messages[validGameId] : null;

  /** ---- SAFETY: IF ASSETS MISSING ---- **/
  if (!preloadedAssets?.Replay) return null;

  return (
     <div
       className="Setting-box"
       style={{
         position: "fixed",
         top: 0,
         left: 0,
         height: "100vh",
         width: "100vw",
         backgroundColor: "rgba(0,0,0,0.5)",
         display: "flex",
         justifyContent: "center",
         alignItems: "center",
         zIndex: 9999,
       }}
     >
       {/* MAIN WRAPPER */}
       <div
         style={{
           position: "relative",
           //   width: "420px",
           height: "auto",
         }}
       >
         {/* BACKGROUND IMAGE */}
         <Img
           src={preloadedAssets?.Replay}
           style={{
             width: "100%",
             borderRadius: "16px",
             display: "block",
           }}
         />
 
         {/* OVERLAY CONTENT SHOWING ON THE IMAGE */}
         <div
           className="popup-text"
           style={{
             position: "absolute",
             top: "0",
             left: "0",
             width: "100%",
             height: "100%",
             display: "flex",
             flexDirection: "column",
             justifyContent: "center",
             alignItems: "center",
             padding: "20px",
             textAlign: "center",
             pointerEvents: "none", // prevents blocking image clicks (optional)
           }}
         >
          
 
           <div className="popup-text" style={{ width: "85%", marginBottom: "20px", pointerEvents: "auto" }}>
             {popupMessage ? (
               <>
                 <h2 className="popup-text" style={{ fontSize: "24px" }}>
                   {popupMessage.title}
                 </h2>
                 <p className="popup-text" style={{ fontSize: "16px", whiteSpace: "pre-line" }}>
                   {popupMessage.description}
                 </p>
               </>
             ) : (
               <>
                 <h2 className="popup-text" style={{ fontSize: "24px" }}>
                   {popupMode === "unlock" ? "New Game Unlocked!" : "Congratulations!"}
                 </h2>
                 <p className="popup-text" style={{ marginTop: "8px", fontSize: "16px" }}>
                   You have successfully completed the game.
                 </p>
               </>
             )}
           </div>
 
 
           {/* BUTTONS */}
           <div
             style={{
               display: "flex",
               gap: "10px",
               width: "80%",
               pointerEvents: "auto", // allows clicking buttons
             }}
             className="popup-button"
           >
             <Button
               onClick={onCancel}
               bg={'none !important'}
               bg-hover={"none"}
               marginLeft={'8%'}
               className="popup-button"
             >
               <Img
                 src={preloadedAssets?.CancelButton}
                 style={{
                   width: "75%",
                   borderRadius: "16px",
                   display: "block",
                 }}
                 className="popup-button"
               />
             </Button>
 
             <Button
               onClick={onContinue}
               bg={'none !important'}
               bg-hover={"none"}
               className="popup-button"
 
             >
               <Img
                 src={preloadedAssets?.ContinueButtonpopup}
                 style={{
                   width: "75%",
                   borderRadius: "16px",
                   display: "block",
                 }}
                 className="popup-button"
 
               />
             </Button>
           </div>
         </div>
       </div>
     </div>
   );
};

/** ---- TITLE RENDER FUNCTION ---- **/
function renderTitle(icon?: string, label?: string) {
  return (
    <span style={{ display: "flex", alignItems: "center", justifyContent: "center", gap: "6px" }}>
      {icon && <img src={icon} alt="" style={{ width: "66px", height: "50px" }} />}
      <span style={{ marginLeft: "-15px" }}>{label}</span>
    </span>
  );
}

export default CognizantPopup;
